import * as moment from "moment/moment";
import * as Handlebars from "handlebars";
import * as i18n from "i18next";
import equals from "./helpers/equals";

Handlebars.registerHelper('equals', equals);

Handlebars.registerHelper('unless', function (v1, options) {
    if (v1) {
        return options.fn(this);
    }
    return options.inverse(this);
});

Handlebars.registerHelper('notequals', function (v1, v2, options) {
    if (v1 == v2) {
        return options.inverse(this);
    }
    return options.fn(this);
});

Handlebars.registerHelper('timestamp', function (timestamp, format) {
    if (timestamp === undefined || timestamp === null || isNaN(timestamp.getTime())) {
        return i18n.t("never");
    }

    var date = new Date(timestamp);

    if (format === undefined || format.hash) {
        format = i18n.t("$datetimeformat");
    }

    return new Handlebars.SafeString(toDate(date, {format: format}));
});

Handlebars.registerHelper('t', function (i18n_key, options) {
    var result;
    let count;
    if (options.hash.count) {
        count = parseInt(options.hash.count);
    } else if (options.hash.hasOwnProperty('count')) {
        count = 0;
    }
    if (options.hash) {
        options.hash.count = count;
        result = i18n.t(i18n_key, options.hash);
    } else {
        result = i18n.t(i18n_key);
    }

    return result;
});

Handlebars.registerHelper('concat', function () {
    return Object.values(arguments).filter(x=>typeof x === "string").reduce((acc, str) => acc + str, "");
});

function toDate(date, options) {
    date = moment.utc(date);

    var localeDate = date.local();
    var formatedDate;
    if (options.relative) {
        formatedDate = localeDate.fromNow();
    }
    else if (options.format) {
        formatedDate = localeDate.format(options.format);
    }

    return new Handlebars.SafeString(formatedDate);
}
